export const NEW_ORGANIZATION_VALUE = 'newOrganization';
export const NEW_CREDENTIAL_VALUE = 'newCredential';
export const CREDENTIAL_TYPE_OAUTH = 'oauth-2';
export const CREDENTIAL_TYPE_CUSTOM = 'custom';
export const INSURANCE_BRYDGE = 'insurance-brydge';
